<template>
  <Modal
    :id="'cmp-catalog-product_groups-document-templates'"
    @cancelled="onCancel"
  >
    <template slot="header">{{$t('submenu_Templates')}}</template>

    <template slot="body">
      <DList
        :items="templates"
        :primaryKey="'booking_template_id'"
        :labelKey="'booking_template_name'"
        :clickable="true"
        :removable="false"
        @item_click="onProductTemplateClick"
      >
      </DList>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { ProductGroupsService } from "../../services/product-groups.service";
import DList from "@dtplugins/list/dlist";
import { MHTTPCL } from "../../../../services/http/http-client";
import { LABEL_URL } from "../../../../services/common-urls";
import { createHttpHeaderOptions } from "../../../b2b/services/http-client";

export default {
  components: {
    Modal,
    DList,
  },
  data() {
    return {
      templates: [],
    };
  },
  async mounted() {
    console.log({ mounted: 1 });
    const res = await ProductGroupsService.documentTemplateModal(
      this.product_group_id
    );
    console.log({ res: res });
    this.templates = res?.data?.templates || [];
  },
  computed: {
    product_group_id() {
      return this.$route.params.product_group_id;
    },
  },
  methods: {
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onProductTemplateClick(item) {
      // https://dev.berlin3.com/designcheck/label.pl?section=product_groups&
      // action=render_template&
      // product_group_id=4&
      // booking_template_id=740
      const { booking_template_id } = item;
      window.open(
        MHTTPCL.getFinalURL(
          LABEL_URL,
          {
            section: "product_groups",
            action: "render_template",
            product_group_id: this.product_group_id,
            booking_template_id: booking_template_id,
          },
          createHttpHeaderOptions({
            noJsonOutput: true,
          })
        )
      );
    },
  },
};
</script>

<style lang="scss">
.cmp-catalog-product_groups-document-templates {
}
</style>